import { useEffect } from "react";

import { getGitRepoName } from "Libs/utils";
import { selectFeatureOrganizationsEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { canCreateProjectOrganizationsSelector } from "Reducers/organization";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import { setupOptionsConfigSelector } from "../setupOptions.selectors";
import { getSetupOptionsThunk } from "../thunks/getSetupOptions.thunk";

export const useLoadSetupOptions = (organizationId?: string) => {
  const dispatch = useAppDispatch();
  const config = useAppSelector(setupOptionsConfigSelector);
  const organizations = useAppSelector(canCreateProjectOrganizationsSelector);
  const organizationEnabled = useAppSelector(selectFeatureOrganizationsEnabled);
  useEffect(() => {
    let options = {} as any;

    const isYaml = /.*.(yaml|yml)/gi.test(config?.template || "");

    if (isYaml) {
      options.template = config?.template;
    } else {
      options = {
        options_custom: {
          repository: config?.template,
          profile: getGitRepoName(config?.template) || "Custom"
        }
      };
    }

    if (organizationEnabled && organizationId) {
      dispatch(getSetupOptionsThunk({ organizationId, ...options }));
    }

    if (!organizations?.length) {
      dispatch(getSetupOptionsThunk(options));
    }
  }, [
    config?.template,
    dispatch,
    organizationId,
    organizationEnabled,
    organizations?.length
  ]);
};
